import i18nFactory from '@yandex-int/i18n';
import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import {
    UpdateInternalMarketerPageStatus,
    updateInternalMarketerPageStatusAction
} from '../../../../actions/marketer/internal/updateInternalMarketerPageStatus';
import {
    UpdateInternalMarketerProduct,
    updateInternalMarketerProductAction
} from '../../../../actions/marketer/internal/updateInternalMarketerProduct';
import {
    UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS,
    UpdateInternalMarketerProductAccess
} from '../../../../actions/marketer/internal/updateInternalMarketerProductAccess';
import { showNoticeMessage } from '../../../../service/GridHelpers/GridHelpers';
import { EpicDeps } from '../../../../service/StoreFactory';
import { NoticeType } from '../../../../typings/grid';
import { MarketersPageStates } from '../../../../typings/marketers';
import { State } from '../../../../typings/state';

import * as keyset from './updateInternalMarketerProductAccessEpic.i18n';

const i18n = i18nFactory(keyset);

type EpicActions = UpdateInternalMarketerProduct | UpdateInternalMarketerPageStatus;

export const updateInternalMarketerProductAccessEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS),
        mergeMap(
            (action: UpdateInternalMarketerProductAccess): Observable<EpicActions> => {
                const {
                    marketerCard: {
                        marketer: { id: marketerId }
                    }
                } = store$.value;

                const { accessType, placeIds, productId } = action;

                return from(
                    deps.marketersDataProvider.updateProductAccess(marketerId, productId, accessType, placeIds)
                ).pipe(
                    mergeMap(product => {
                        showNoticeMessage(NoticeType.success, i18n('change-success'));

                        return of(
                            updateInternalMarketerProductAction(product, { isSaved: true }),
                            updateInternalMarketerPageStatusAction(MarketersPageStates.LOADED)
                        );
                    }),
                    catchError(() => {
                        showNoticeMessage(NoticeType.error, i18n('error'));

                        return of(updateInternalMarketerPageStatusAction(MarketersPageStates.PENDING));
                    })
                );
            }
        )
    );
